import { Component, EventEmitter, Input, OnInit, Output, HostListener } from '@angular/core';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

    @Input() totalItems: number;
    @Input() currentPage: number;
    @Input() itemsPerPage: number;

    @Output() changePage = new EventEmitter();
    
    isFloating = false;
    floatingDivPosition = 0;


  constructor() { }

  pager: any = {};

    ngOnInit() {
        console.log('inside pagination')
        console.log('inside pagination')
        this.floatingDivPosition = $('#pagination').offset().top - 15;
    }

  ngOnChanges() {
    this.renderPagination(this.currentPage,this.totalItems,this.itemsPerPage)
  }

  renderPagination(currentPage: number,totalItems: number,pageSize: number) {
      // get pager object from service
      this.pager = this.getPager(totalItems, currentPage,pageSize);
  }

  setPage(currentPage: number,totalItems: number,pageSize: number) {
      // get pager object from service
    this.changePage.emit(currentPage);
    this.pager = this.getPager(totalItems, currentPage,pageSize);
  }

  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSize);

        // ensure current page isn't out of range
        if (currentPage < 1) { 
            currentPage = 1; 
        } else if (currentPage > totalPages) { 
            currentPage = totalPages; 
        }
        
        let startPage: number, endPage: number;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    @HostListener("window:scroll", ["$event"])
    onWindowScroll() {
        this.isFloating = $(window).scrollTop() > this.floatingDivPosition ? true : false;
  }
}